import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Topbar from "../../components/Topbar";
import Leftbar from "../../components/Leftsidebar";
import { Link } from "react-router-dom";
import Loaderspinner from "../../components/Loader";
import { Tabs, Tab, Row, Col } from "react-bootstrap";
import UserList from "../../components/Resources/UserList";
import CompaniesList from "../../components/Resources/CompaniesList";
import VideosList from "../../components/Resources/VideosList";
import Checklist from "../../components/Resources/Checklist";
import { resourceDetail } from "../Utils/utils";

const ManageResource = () => {
	const { id } = useParams();

	const [showSidebar, setShowSidebar] = useState(false);
	const [activeTab, setActiveTab] = useState("agents");
	const [loading, setLoading] = useState(false);
	const [resourceName, setResourceName] = useState('')

	const handleSidebar = () => {
		setShowSidebar(!showSidebar);
	};

	const handleSidebarClose = () => {
		setShowSidebar(false);
	};

	useEffect(() => {
		fetchDetails();
	}, [id]);

	const fetchDetails = async () => {
		try {
			setLoading(true);

			const res = await resourceDetail(id);

			if (res?.status == 200) {
				setResourceName(res.data?.title);
			}

		} catch (error) {
			console.error(error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<>
			{loading && <Loaderspinner />}
			<div class="g-sidenav-show  bg-gray-100 min-vh-100">
				<div id="wrapper">
					<Leftbar showSidebar={showSidebar}
						handleSidebarClose={handleSidebarClose} />
					<main className="main-content border-radius-lg">
						<Topbar handleSidebar={handleSidebar} />
						<div>
							<div className="header header-bg pb-6">
								<div className="container-fluid">
									<div className="header-body">
										<div className="row align-items-center py-4">
											<div className="col-lg-6 col-7">
												<nav
													aria-label="breadcrumb"
													className="d-none d-md-inline-block ml-md-4"
												>
													<ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
														<li className="breadcrumb-item">
															<Link to="/dashboard">
																<i className="fas fa-home" />
															</Link>
														</li>
														<li className="breadcrumb-item">
															<Link to="/resources"><span className="" style={{ color: " #f6f9fc", fontSize: "15px", textDecoration: "none" }}>Resources</span></Link>
														</li>
														<li className="breadcrumb-item">
															<Link to=""><span className="" style={{ color: " #f6f9fc", fontSize: "15px", textDecoration: "none" }}>Manage Resource</span></Link>
														</li>
														<li className="breadcrumb-item">
															<Link to="">
																<span style={{ color: " #f6f9fc", fontSize: "15px" }}>
																	{activeTab.charAt(0).toUpperCase() + activeTab.slice(1)}
																</span>
															</Link>
														</li>
													</ol>
												</nav>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="container-fluid mt--6">
								<div className="row">
									<div className="col">
										<div className="card">

											<div className="card-body">
												<h5 style={{ fontSize: "18px", marginBottom: "16px" }}>{resourceName}</h5>

												<Tabs
													activeKey={activeTab}
													onSelect={(k) => setActiveTab(k)}
													className="mb-3 resource-tabs"
												>
													<Tab eventKey="agents" title="Agents">
														<div className="p-3">
															<UserList id={id} />
														</div>
													</Tab>

													<Tab eventKey="companies" title="Companies">
														<div className="p-3">
															<CompaniesList id={id} />
														</div>
													</Tab>

													<Tab eventKey="videos" title="Videos">
														<div className="p-3">
															<VideosList id={id} />
														</div>
													</Tab>
													<Tab eventKey="checklist" title="Checklist">
														<div className="p-3">
															<Checklist id={id} />
														</div>
													</Tab>

													{/* <Tab eventKey="videos" title="Videos">
                                                        <div className="p-3">
                                                            Videos Management UI
                                                        </div>
                                                    </Tab>

                                                    <Tab eventKey="checklist" title="Checklist">
                                                        <div className="p-3">
                                                            Checklist UI
                                                        </div>
                                                    </Tab> */}

												</Tabs>

											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</main>
				</div>
			</div>
		</>
	);
};

export default ManageResource;
